/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_TaglineInputs */

const en_svc_programmatic_seo_tagline = /** @type {(inputs: Svc_Programmatic_Seo_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thousands of search-optimized pages, generated and kept fresh automatically.`)
};

const ar_svc_programmatic_seo_tagline = /** @type {(inputs: Svc_Programmatic_Seo_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آلاف الصفحات المحسنة للبحث، تولد وتبقى حديثة تلقائيا.`)
};

const bn_svc_programmatic_seo_tagline = /** @type {(inputs: Svc_Programmatic_Seo_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হাজার হাজার সার্চ-অপ্টিমাইজড পৃষ্ঠা, স্বয়ংক্রিয়ভাবে তৈরি আর তাজা রাখা।`)
};

const de_svc_programmatic_seo_tagline = /** @type {(inputs: Svc_Programmatic_Seo_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tausende suchmaschinenoptimierte Seiten, automatisch generiert und frisch gehalten.`)
};

const es_svc_programmatic_seo_tagline = /** @type {(inputs: Svc_Programmatic_Seo_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miles de páginas optimizadas para buscadores, generadas y frescas automáticamente.`)
};

const fr_svc_programmatic_seo_tagline = /** @type {(inputs: Svc_Programmatic_Seo_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des milliers de pages optimisées pour la recherche, générées et gardées fraîches automatiquement.`)
};

const pt_svc_programmatic_seo_tagline = /** @type {(inputs: Svc_Programmatic_Seo_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milhares de páginas otimizadas para pesquisa, geradas e frescas automaticamente.`)
};

const zh_svc_programmatic_seo_tagline = /** @type {(inputs: Svc_Programmatic_Seo_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成千上万的搜索优化页面，自动生成并持续保鲜。`)
};

const tr_svc_programmatic_seo_tagline = /** @type {(inputs: Svc_Programmatic_Seo_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binlerce arama uyumlu sayfa, otomatik üretilir ve taze tutulur.`)
};

const ru_svc_programmatic_seo_tagline = /** @type {(inputs: Svc_Programmatic_Seo_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тысячи поисковых страниц, генерируются и свежеют автоматически.`)
};

const pl_svc_programmatic_seo_tagline = /** @type {(inputs: Svc_Programmatic_Seo_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tysiące stron pod wyszukiwarki, generowane i utrzymywane świeżo automatycznie.`)
};

/**
* | output |
* | --- |
* | "Thousands of search-optimized pages, generated and kept fresh automatically." |
*
* @param {Svc_Programmatic_Seo_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_tagline = /** @type {((inputs?: Svc_Programmatic_Seo_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_tagline(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_tagline(inputs)
	if (locale === "de") return de_svc_programmatic_seo_tagline(inputs)
	if (locale === "es") return es_svc_programmatic_seo_tagline(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_tagline(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_tagline(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_tagline(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_tagline(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_tagline(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_tagline(inputs)
	return en_svc_programmatic_seo_tagline(inputs)
});
export { svc_programmatic_seo_tagline as "svc_programmatic-seo_tagline" }